import { render, staticRenderFns } from "./SlSwitchNav.vue?vue&type=template&id=8a13b404&scoped=true&"
import script from "./SlSwitchNav.vue?vue&type=script&lang=js&"
export * from "./SlSwitchNav.vue?vue&type=script&lang=js&"
import style0 from "./SlSwitchNav.vue?vue&type=style&index=0&id=8a13b404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a13b404",
  null
  
)

export default component.exports